import React, { useState } from 'react';
import { Layout, Typography } from 'antd';
import { useSelector } from 'react-redux';
import SidebarPanel from './SidebarPanel';
import Canvas from './Canvas';
import NodeConfigModal from '../NodeConfigModal/NodeConfigModal';
import WorkflowStatus from '../WorkflowStatus/WorkflowStatus';
import { useSandbox } from '../../hooks/sandbox/useSandbox';
import { t } from '../../i18n/i18n';
import AlkyMationLogo from '../../assets/AlkyMationLogo';
import './Sandbox.scss';

const { Sider, Content, Header } = Layout;
const { Title } = Typography;

const Sandbox = () => {
  const sandbox = useSandbox();
  const { user, currentWorkspace } = useSelector((state) => state.auth);
  const [collapsed, setCollapsed] = useState(false);
  const [rightCollapsed, setRightCollapsed] = useState(false);

  return (
    <div className="n8n-sandbox">
      <Layout className="sandbox-layout">
        <Header className="sandbox-header">
          <Title level={3} className="mb-0 text-white">
            {t('ALKYMATION_TITLE')}
          </Title>
          <AlkyMationLogo width={50} height={50} color="#FFFFFF" />
        </Header>

        <Layout>
          <Sider
            width={350}
            className="sandbox-sider"
            theme="light"
            trigger={null}
            collapsible
            collapsed={collapsed}
            collapsedWidth={80}
            onCollapse={setCollapsed}
          >
            <SidebarPanel
              sandbox={sandbox}
              userId={user?.id}
              collapsed={collapsed}
              setCollapsed={setCollapsed}
            />
          </Sider>

          <Content className="sandbox-content">
            <Canvas sandbox={sandbox} />
          </Content>

          <Sider
            width={350}
            className="sandbox-status-sider"
            theme="light"
            trigger={null}
            collapsible
            collapsed={rightCollapsed}
            collapsedWidth={80}
            onCollapse={setRightCollapsed}
            reverseArrow
          >
            <WorkflowStatus
              workflow={sandbox.workflow}
              userId={user?.id}
              workspaceId={currentWorkspace}
              collapsed={rightCollapsed}
              setCollapsed={setRightCollapsed}
            />
          </Sider>
        </Layout>
      </Layout>

      <NodeConfigModal sandbox={sandbox} />
    </div>
  );
};

export default Sandbox;
